import { useEffect } from "react";
import { LegalPage, LegalSection } from "@/components/LegalPage";

export default function Voorwaarden() {
  useEffect(() => {
    document.title = "Algemene Voorwaarden | WanneerKaartverkoop.nl";
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalPage
      testid="voorwaarden-page"
      eyebrow="Juridisch"
      title="Algemene Voorwaarden"
      intro="Laatst bijgewerkt: oktober 2026. Van toepassing op elk gebruik van Wanneerkaartverkoop.nl."
    >
      <LegalSection title="1. Wie wij zijn">
        <p>
          Wanneerkaartverkoop.nl (KvK 42205037, BTW NL005581110B78) is een onafhankelijk
          informatieplatform dat bijhoudt wanneer de kaartverkoop en pre-sale van festivals,
          concerten en andere events start. Bereikbaar via{" "}
          <a href="mailto:info@wanneerkaartverkoop.nl" className="text-blaze hover:underline">info@wanneerkaartverkoop.nl</a>.
        </p>
      </LegalSection>
      <LegalSection title="2. Informatief karakter">
        <p>
          Alle vermelde verkoopdata, -tijden en eventinformatie zijn puur informatief. Ze zijn
          afkomstig van organisatoren en openbare bronnen en worden met zorg bijgehouden, maar
          er kunnen geen rechten aan worden ontleend. Ticket-aanbieders en organisatoren kunnen
          data, tijden en prijzen op elk moment en zonder aankondiging wijzigen.
        </p>
      </LegalSection>
      <LegalSection title="3. Geen ticketverkoper">
        <p>
          Wanneerkaartverkoop.nl verkoopt zelf geen tickets en is geen partij bij jouw aankoop.
          Wij verwijzen door naar officiële ticketpartners; de overeenkomst komt altijd tot
          stand tussen jou en die aanbieder, onder de voorwaarden van die aanbieder.
        </p>
      </LegalSection>
      <LegalSection title="4. Aansprakelijkheid">
        <p>
          Wij zijn niet aansprakelijk voor wijzigingen, fouten of vertragingen in de informatie
          van ticket-aanbieders, noch voor gemiste kaartverkopen of andere schade die voortvloeit
          uit het gebruik van deze website. Controleer de definitieve informatie altijd op de
          website van de organisator of het officiële verkoopkanaal.
        </p>
      </LegalSection>
      <LegalSection title="5. Affiliate-links">
        <p>
          Wanneer je via onze links een aankoop doet bij een ticketpartner, kunnen wij een kleine
          commissie ontvangen. Dit kost jou niets extra en beïnvloedt de door ons getoonde
          verkoopinformatie niet.
        </p>
      </LegalSection>
      <LegalSection title="6. Vragen of klachten">
        <p>
          Vragen over deze voorwaarden of een correctie doorgeven? Neem contact op via de{" "}
          <a href="/contact" className="text-blaze hover:underline">contactpagina</a> of mail{" "}
          <a href="mailto:info@wanneerkaartverkoop.nl" className="text-blaze hover:underline">info@wanneerkaartverkoop.nl</a>.
          Op deze voorwaarden is Nederlands recht van toepassing.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
